<template>
  <div class="button-group">
    <button class="btn btn-secondary" @click="$emit('back')" v-if="backButtonIsVisible">返回</button>
    <button
      class="btn btn-primary"
      :disabled="!canProceed"
      :style="!canProceed ? { opacity: '0.6', cursor: 'not-allowed' } : {}"
      @click="$emit('next')"
    >
      {{ textForNextStep }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'TongxinNavigation',
  props: {
    canProceed: {
      type: Boolean,
      default: false,
    },
    backButtonIsVisible: {
      type: Boolean,
      default: true,
    },
    textForNextStep: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: center; // 一個按鈕時置中
  gap: 20px;

  .btn {
    flex: 1;
  }

  .btn + .btn {
    margin-left: auto; // 兩個按鈕時，分散兩側對齊
  }
}
</style>
